import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const switchButtonCSS = css({
  position: "relative",
  display: "inline-block",
  width: "40px",
  height: "24px",
  padding: "2px",
  overflow: "hidden",

  backgroundColor: vars.semantic.color.actionPrimaryTonal,
  borderRadius: "50px",
  transition: "all 0.1s ease-out",

  cursor: "pointer",

  "input:checked:disabled + &": {
    backgroundColor: vars.semantic.color.actionPrimary,
    opacity: 0.3,
    cursor: "not-allowed",
  },

  "input:not(:disabled) + &:hover": {
    backgroundColor: vars.semantic.color.actionPrimaryTonalHover,
  },

  "input:not(:disabled):checked + &": {
    backgroundColor: vars.semantic.color.actionPrimary,

    "&:hover": {
      backgroundColor: vars.semantic.color.actionPrimaryHover,
    },
  },

  "input:checked + &": {
    "&:before": {
      left: "calc(100% - 22px)",
    },
  },

  "input:disabled + &": {
    backgroundColor: vars.semantic.color.actionPrimaryTonalDisabled,
    cursor: "not-allowed",
  },

  "&::before": {
    position: "absolute",
    content: "''",
    left: "2px",

    width: "20px",
    height: "20px",
    backgroundColor: vars.semantic.color.surface,
    boxShadow: "0px 3px 8px 0px rgba(0, 0, 0, 0.15)",
    borderRadius: "100%",

    transition: "all 0.1s ease-out",
  },
});
